var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 213.53 213.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-miterlimit:10;stroke-width:1.5px;}.cls-1{stroke:#2b338d;}.cls-2{stroke:#55575b;}.cls-3{fill:#95c93d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OBXIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.89,161.63a53,53,0,1,0-53-53v0",
    transform: "translate(-1.15 -1.77)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.89,29a79.5,79.5,0,1,0,79.53,79.5",
    transform: "translate(-1.15 -1.77)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.89,214.55a106,106,0,1,0-106-106v0",
    transform: "translate(-1.15 -1.77)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.37,103.1h19.49V83.81h14.2V103.1h19.41v13.36H115.06v19.38h-14.2V116.46H81.37Z",
    transform: "translate(-1.15 -1.77)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObxIcon);
export default __webpack_public_path__ + "static/media/OBXIcon.8b5655f03b4ac9506e5552784e486a2a.svg";
export { ForwardRef as ReactComponent };